import { extendBaseTheme } from "@chakra-ui/react";
// `@chakra-ui/theme` is a part of the base install with `@chakra-ui/react`
import chakraTheme from "@chakra-ui/theme";

const theme = extendBaseTheme({
  ...chakraTheme,
});

export default theme;
